import axios from 'axios'
import { parametrosEnFormatoURL } from 'sisdai-mapas/src/utiles'

const geoserver = process.env.VUE_APP_GEMA_GEOSERVER
export const urls = {
  cdn: process.env.VUE_APP_CDN_ARCHIVOS,
  api: process.env.VUE_APP_API_URL,
  wms: `${geoserver}/wms`,
}

// VER DE QUE MANERA PODEMOS TRAER LOS FEATURES DESDE LA CAPA
export function urlFeatures(params) {
  const parametros = {
    service: 'WFS',
    version: '2.0.0',
    request: 'GetFeature',
    outputFormat: 'application/json',
    typeName: undefined,
    propertyName: undefined,
    cql_filter: undefined,
  }

  return `${geoserver}/ows?${parametrosEnFormatoURL({ ...parametros, ...params })}`
}
export const consultar = (url, f, e = () => {}) => axios(url).then(f).catch(e)
export const ordenarBbox = bbox => [bbox[1], bbox[0], bbox[3], bbox[2]]
export const extensionInicial = '-118.3651,14.5321,-86.7104,32.7187'

export const info = {
  casaComedor: p =>
    `<p class="m-t-0">${p.tipo} "${p.nombre}"</b></p><p class="m-b-0">${[
      `Personas beneficiadas: <b>${p.ben_total}</b>`,
      `Región indígena: <b>${p.region}</b>`,
      `Estado: <b>${p.nom_ent}</b>`,
      `Municipio: <b>${p.nom_mun}</b>`,
      `Localidad: <b>${p.nom_loc}</b>`,
    ].join('<br />')}</p>`,
  centroCoordinador: p =>
    `<p class="m-t-0">Centro Coordinador "${p.nombre}"</p><p class="m-b-0">${[
      `Contacto: <b>${p.correo}</b>`,
      `Estado: <b>${p.nom_ent}</b>`,
      `Municipio: <b>${p.nom_mun}</b>`,
      `Localidad: <b>${p.nom_loc}</b>`,
    ].join('<br />')}</p>`,
  comunidad: p =>
    `<p class="m-t-0">Comunidad indígena: <b>${p.nom_com}</b></p><p class="m-b-0">${[
      // `Nombre de la comunidad en la lengua indígena: <b>${p.pi_hogares}</b>`,
      `Pueblo: <b>${p.nom_pueblo1}</b>`,
      // `Autodenominación: <b>${p.programa}</b>`,
      `Estado: <b>${p.nom_ent}</b>`,
      `Municipio: <b>${p.nom_mun}</b>`,
      `Localidad: <b>${p.nom_loc}</b>`,
    ].join('<br />')}</p>`,
  escuela: p =>
    `<p class="m-t-0">Establecimiento escolar</p><p class="m-b-0">${[
      `Nombre: <b>${p.nom_centro}</b>`,
      `Nivel: <b>${p.niv_edu}</b>`,
      `CCT: <b>${p.cv_centro}</b>`,
      `Estado: <b>${p.nom_ent}</b>`,
      `Municipio: <b>${p.nom_mun}</b>`,
      // `Localidad: <b>${p.nom_loc}</b>`,
    ].join('<br />')}</p>`,
  hospital: p =>
    `<p class="m-t-0">Hospital</p><p class="m-b-0">${[
      `Nombre: <b>${p.nom_unidad}</b>`,
      `Nivel de atención: <b>${p.nivel_atencion}</b>`,
      `Institución: <b>${p.nom_inst}</b>`,
      `Estado: <b>${p.nom_ent}</b>`,
      `Municipio: <b>${p.nom_mun}</b>`,
      `Localidad: <b>${p.nom_loc}</b>`,
    ].join('<br />')}</p>`,
  hospitalN1: p =>
    `<p class="m-t-0">Hospital</p><p class="m-b-0">${[
      `Nombre: <b>${p.nom_unidad}</b>`,
      `Nivel de atención: <b>${p.nivel_atencion}</b>`,
      `Institución: <b>${p.nom_inst}</b>`,
      `Estado: <b>${p.nom_entidad}</b>`,
      `Municipio: <b>${p.nom_municipio}</b>`,
      `Localidad: <b>${p.nom_localidad}</b>`,
    ].join('<br />')}</p>`,
  nucleo: p =>
    `<p class="m-t-0">Núcleo agrario: <b>${p.nom_nucleo}</b></p><p class="m-b-0">${[
      `Población indígena: <b>${p.pi_hogares}</b>`,
      `Tipo: <b>${p.tipo_propie}</b>`,
      `Programa: <b>${p.programa}</b>`,
    ].join('<br />')}</p>`,
  oficinaRepre: p =>
    `<p class="m-t-0">${p.nombre}</p><p class="m-b-0">${[
      `Contacto: <b>${p.correo}</b>`,
      `Estado: <b>${p.nom_ent}</b>`,
      `Municipio: <b>${p.nom_mun}</b>`,
      `Localidad: <b>${p.nom_loc}</b>`,
    ].join('<br />')}</p>`,
  pueblo: (p, pueblo) =>
    `<p class="m-t-0">Población indígena ${pueblo}</p><p class="m-b-0">${[
      `Pueblo: <b>${p.nombre_pueblo}</b>`,
      `Población: <b>${p.pihogares}</b>`,
      `Estado: <b>${p.nom_ent}</b>`,
      `Municipio: <b>${p.nom_mun}</b>`,
      `Localidad: <b>${p.nom_loc}</b>`,
    ].join('<br />')}</p>`,
  radiodifusora: p =>
    `<p class="m-t-0">${p.nombre}</p><p class="m-b-0">${[
      `Contacto: <b>${p.correo}</b>`,
      `Estado: <b>${p.nom_ent}</b>`,
      `Municipio: <b>${p.nom_mun}</b>`,
      `Localidad: <b>${p.nom_loc}</b>`,
    ].join('<br />')}</p>`,
  territorio: p =>
    `<p class="m-t-0">Territorio del pueblo: <b>${p.pueblo}</b></p><ul class="p-l-0" style="list-style: none;">${[
      // `<li class="m-t-0">Superficie: <b>${p.}</b></li>`,
      `<li class="m-t-0">Lengua: <b>${p.lengua}</b></li>`,
      `<li class="m-t-0">Fuente del dato: <b>${p.fuente}</b></li>`,
    ].join('')}</ul>`,
}

export const ordenCapas = JSON.parse(
  `{${[
    'base',
    'gref_division_estatal_20_est_a',
    'gref_division_municipal_20_mun_a',
    'pciaf_territorios_pueb_indig_07_nal_a',
    'pciaf_pob_ind_nucleos_agrarios_21_nal_a',
    'pciaf_pob_indigena_residentes_20_loc_p',
    'pciaf_pob_indigena_asent_hist_20_loc_p',
    'p_indigenas_comunidades_17122021',
    'gref_corredores_red_nac_caminos_21_nal_l',
    'educ_establecimientos_escolares_15_xy_p',
    'salu_unidades_medicas_1n_clues_21_xy_p',
    'salu_unidades_medicas_2n_clues_21_xy_p',
    'salu_unidades_medicas_3n_clues_21_xy_p',
    'pciaf_casas_comedores_ninez_ind_21_xy_p',
    'pciaf_radiodifusoras_ind_160124_xy_p',
    'pciaf_oficinas_repre_inpi_160124_xy_p',
    'pciaf_centros_coord_pue_ind_160124_xy_p',
  ]
    .map((capa, idx) => `"${capa}":${idx}`)
    .join(',')}}`
)
